import React from 'react';
import { useParams } from 'react-router-dom';

import MerchantStoreForm from '../../components/merchantStores/MerchantStoreForm';
import {
  useMerchantStoreByIdRelayQuery,
  mapMerchantStore,
} from '../../hooks/merchantStores/query/V2';

const MerchantStoreEdit = () => {
  const { merchantStoreId } = useParams<{ merchantStoreId: string }>();
  const { data, isLoading } = useMerchantStoreByIdRelayQuery(merchantStoreId, {
    enabled: Boolean(merchantStoreId),
  });

  const store = data ? mapMerchantStore(data) : undefined;
  const detailHref = `/branded-app/merchant-locations/${merchantStoreId}/general`;

  return (
    <MerchantStoreForm
      // The form seeds its state on mount, so remount once the record lands.
      key={store?.id ?? 'loading'}
      mode="edit"
      merchantStoreId={merchantStoreId}
      initialValues={store}
      isLoading={isLoading}
      cancelHref={detailHref}
      successHref={detailHref}
      title="Edit Merchant Location"
    />
  );
};

export default MerchantStoreEdit;
